<template>
	<div>
		
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="btn">
			<div class="jiams tj">
				<div>供应商：</div>
				<Select v-model="query.opers" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo1">
				        <Option v-for="item in opers" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<div class="comm tj">
				<div>设备：</div>
				<Select v-model="query.macs" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo2">
				        <Option v-for="item in macs" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<div class="time tj">
				<div>时间：</div>
				<div class="time-xz">
					<DatePicker type="datetime" placeholder="开始时间" v-model='kaishi' style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
					<div>--</div>
					<DatePicker type="datetime" placeholder="结束时间" v-model='jieshu' style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"  ></DatePicker>
				</div>
			</div>
		</div>
		
		<tongji :map="map"></tongji>

		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
			 	<!-- <Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button> -->
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	import tongji from '../../../comm/tongji.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading:false,
				kaishi:'',
				jieshu:'',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//供应商列表
				opers: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [{
						title: '订单id',
						key: 'id'
					},
					{
						title: '支付方式',
						key: 'payType'
					},
					{
						title: '设备id',
						key: 'macLeaveFactoryId'
					},
					{
						title: '用户id',
						key: 'clientId'
					},
					{
						title: '总金额',
						key: 'money',
						render: (h, params) => {
							return h("div",params.row.money)
						}
					},
					{
						title: '抽成方式',
						key: 'commissionWay',
						render: (h, params) => {
							if(params.row.commissionWay==0){
								return h("div","总金额")
							}else if(params.row.commissionWay==1){
								return h("div","一级分类")
							}else if(params.row.commissionWay==2){
								return h("div","二级分类")
							}else{
								return h("div","三级分类")
							}
							
						}
					},
					{
						title: '抽成比例',
						key: 'rake',
						render: (h, params) => {
							return h("div",params.row.rake/100+"%")
						}
					},
					
					{
						title: '抽成金额',
						key: 'commissionMoney',
						render: (h, params) => {
							return h("div",params.row.commissionMoney)
						}
					},
					{
						title: '指令是否下发',
						key: 'isShipment',
						render: (h, params) => {
							if(params.row.isShipment){
								return h("div",{
									style: {
									             color: '#19be6b'
									          }
								},"指令已下发")
							}else{
								return h("div",{
									style: {
									             color: '#ed4014'
									          }
								},"指令未下发")
							}
							
						}
					},
					{
						title: '出货结果',
						key: 'result',
						render: (h, params) => {
							if(params.row.result=='正常'){
								return h("div",{
									style: {
									             color: '#19be6b'
									          }
								},"正常")
							}else if(params.row.result=='暂无'){
								return h("div",{
									style: {
									             color: '#ff9900'
									          }
								},"暂无")
							}else{
								return h("div",{
									style: {
									             color: '#ed4014'
									          }
								},"异常")
							}
							
							
						}
					},
					{
						title: '是否退款',
						key: 'isrefund',
						render: (h, params) => {
							if(params.row.isrefund==null){
								return h("div","")
							}else{
								
								switch (params.row.isrefund){
									case '1':
								        return h("div",{
											style: {
											             color: '#ff9900'
											          }
										},"正在退款")
										break;
									case '2':
								        return h("div",{
											style: {
											             color: '#19be6b'
											          }
										},"已退款")
										break;
									default:
									return h("div","未退款")
										break;
								}
							}
							
						}
					},
					{
						title: '时间',
						key: 'createdTime'
					},
					// {
					// 	title: '操作',
					// 	slot: 'action',
					// 	width: 80,
					// 	align: 'center'
					// }
				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '10',
					opers:[],
					macs:[],
					comms:[],
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
				},
				map:{
					yearMoney:'--',
					monthMoney:'--',
					dayMoney:'--'
				}
			}
		},
		methods: {
			xiangqing(item){
				let _this=this
				this.$router.push({
					name: 'jm/platform/finance/operOrderDetails',
					query: {
						orderId: item.id,
					}
				})
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				_this.query.kaishiTime=time
			},
			onchangeJieshu(time){
				let _this=this
				_this.query.jieshuTime=time
			},
			onok(){
				let _this=this
				this.query.page=0
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){
					if(ks >=js){
						_this.$Message.error('开始时间必须小于结束时间!');
					}else{
						
						//重新渲染子组件
						this.showPage = false
						this.$nextTick(() => {
							this.showPage = true
						}) 
						_this.ajaxPage()
						this.queryOperStatistics()
					}
					
				}else{
					
					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}
			},
			onclear(){
				let _this=this
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
				this.queryOperStatistics()
			},
			onchangeSousuo1(){
				
				let _this=this
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
				_this.queryMacs()
			    this.queryOperStatistics()
			},
			onchangeSousuo2(){
				
				let _this=this
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			    this.queryOperStatistics()
			},
			//查询条件
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/jm/oper',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryOperStatistics(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/jm/statistics/oper',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.map = data.map
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryOper(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let items = data.opers.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].companyName
							_this.opers.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			queryMacs(){
				let _this=this
				let q={
					page:0,
					size:1000,
					ids:[]
				}
				q.ids=_this.query.opers
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/oper1',
				    data: q,
					_this: _this,
					success: function(data) {
						let items = data.macLeaveFactorys.content
						_this.macs=[]
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].macCode
							_this.macs.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}

		},
		components: {
			page,tongji
		},
		created() {
			let _this=this
			_this.kaishi=_this.$route.query.kaishi
			_this.jieshu=_this.$route.query.jieshu
			_this.query.kaishiTime=_this.$route.query.kaishi
			_this.query.jieshuTime=_this.$route.query.jieshu
			for (let i = 0; i < _this.$route.query.opers.length; i++) {
				_this.query.opers.push(_this.$route.query.opers[i]+"")
			}
			_this.query.macs.push(_this.$route.query.macId)
			_this.queryOper()
		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			console.log(to.name)
			if(to.name=='jm/platform/finance/oper/earnings/mac'){
			    to.meta.keepAlive = true;
			    from.meta.keepAlive = false;
				this.$destroy(); //销毁B的实例
				next();//当我们前进的不是C时我们让B页面刷新
			}else{
			    from.meta.keepAlive = true;
				to.meta.keepAlive = false;
				next()
			}
		}, 
		
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		width: 100%;
		display: flex;
		margin:10px;
		.item{
		    margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/finance/operList.vue